<template>
  <div class="content ht-100v pd-0">
    <div class="content-body pd-10">
      <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
              <li class="breadcrumb-item">
                <router-link to="#">Projects</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">All Projects</li>
            </ol>
          </nav>
          <h4 class="mg-b-0 tx-spacing--1">View All Projects</h4>
          <p class="tx-color-03 tx-12 mg-b-0">{{auth.userInfo.firstName}} {{auth.userInfo.lastName}}</p>
          <!--                    <p class="tx-color-03 tx-12 mg-b-0"><strong>Last login:</strong> {{auth.userInfo.userLastLoginDate | moment('dddd, MMMM Do YYYY, h:mm:ss a')}}</p>-->
        </div>
        <div class="d-none d-md-block">
          <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5" @click="showModal = !showModal"><plus-icon class="wd-10 mg-r-5" /> Add Project</button>
          <download-excel
              :data="projects"
              class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
            <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadExcel')}}
          </download-excel>
          <download-excel
              type="csv"
              :data="projects"
              class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
            <PrinterIcon class="mg-r-5"/>{{$t('extra.downloadCsv')}}
          </download-excel>

        </div>
      </div>
      <base-top-cards :carditems="cards"/>
      <hr>

      <base-table
          :items="projects"
          :fields="fields"
          :show-title="true"
          :is-busy="project.projectLoading"
          class="mt-2"
          filter-mode="balances"
      ></base-table>
    </div>
    <create-project-modal :show="showModal" :row="{}" />
  </div>
</template>

<script>
import BaseTopCards from "../../components/card/BaseTopCards";
import BaseTable from "../../components/table/BaseTable";
// import BaseButton from "../../components/button/BaseButton";
import CreateProjectModal from "@/components/modal/CreateProjectModal";
import { PrinterIcon, PlusIcon } from 'vue-feather-icons'
import {mapState} from 'vuex'

export default {
  name: 'Loan',
  data() {
    return {
      showModal: true,
      model:{
        projectCode: '',
        projectName: '',
        projectEmployerId: '',
        projectMaker: '',
        projectSalaryDay: '',
        projectSalaryPeriod: 'MONTHLY',
        projectType: 'JUNIOR'
      },
      fields: [
        { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc' },
        { key: 'projectTitle', label: 'Project Title', sortable: true, sortDirection: 'desc' },
        { key: 'projectDescription', label: 'Project Name', sortable: true, class: 'text-left' },
        { key: 'projectProgress', label: 'Progress', sortable: true, class: 'text-left' },
        { key: 'projectStatus', label: 'Status', sortable: true, class: 'text-left' },
        { key: 'projectStatus', label: 'Comments', sortable: true, class: 'text-left' },
        { key: 'projectStatus', label: 'Tasks', sortable: true, class: 'text-left' },
        // { key: 'actionsProject', label: 'Action', sortable: true, class: 'text-center' }
        { key: 'actionsProject', label: 'Action', sortable: true, class: 'text-center' }
      ],
    }
  },
  components: {
    PlusIcon,
    BaseTable,
    CreateProjectModal,
    BaseTopCards,
    PrinterIcon
  },
  computed: {
    cards:{
      get(){
        return [
          {
            id: 0,
            name: 'Total Projects',
            number: this.projects.length,// == null?'0.00':'GHS '+this.numberWithCommas(this.totalGhs),
            color: 'bg-primary'
          },
          {
            id: 1,
            name: 'Open Projects',
            number: this.projects.filter(it => it.projectStatus.toUpperCase() === 'OPEN').length,// == null?'0.00':'GBP '+this.numberWithCommas(this.totalGbp),
            color: 'bg-orange'
          },
          {
            id: 2,
            name: 'Closed Projects',
            number: this.projects.filter(it => it.projectStatus.toUpperCase() === 'CLOSED').length,// == null?'0.00':'USD '+this.numberWithCommas(this.totalUsd),
            color: 'bg-success'
          },
          {
            id: 3,
            name: 'Suspended Projects',
            number: this.projects.filter(it => it.projectStatus.toUpperCase() === 'SUSPENDED').length,// == null?'0.00':'EUR '+this.numberWithCommas(this.totalEur),
            color: 'bg-black-8'
          }
        ]
      },
      set(){

      }
    },
    projects(){
      return  this.project.projects
    },
    authobj: function () {
      return this.$store.state.auth.response
    },
    ...mapState([
      'project',
      'auth'
    ])
  },
  methods: {
    async createProject(){
      this.model.projectMaker = `${this.auth.userInfo.firstName} ${this.auth.userInfo.lastName}`
      this.model.projectEmployerId = localStorage.orgId
      await this.$store.dispatch("project/createProject", this.model, {root: false})
      this.loadProject();
      this.hide();
      let self = this;
      // eslint-disable-next-line no-unused-vars
      Object.keys(this.model).forEach(function(key,index) {
        self.model[key] = '';
      });

    },
    loadProject(){
      this.$store.dispatch("project/updateProjects", {
        readAll:'NO',
        employer: localStorage.orgId
      }, {root: false}).then()
    },
    hide() {
      this.$refs['project-modal'].hide()
    },
    numberWithCommas(x) {
      let parts = x.toString().split(".");
      if (parts[1] == null)  parts[1] = '00'
      else if (parts[1].length === 0) parts[1] = parts[1]+'00'
      else if (parts[1].length === 1) parts[1] = parts[1]+'0'
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  created() {
    this.$store.dispatch('project/updateProjects', {
      readAll: 'YES',
      employer: localStorage.orgId,
      employee: ''
    })
  }
}


</script>

<style scoped>

</style>
